import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

interface CardProps {
  title: string;
  selected?: boolean;
  className?: string;
}

const Card: FunctionComponent<CardProps> = ({
  title,
  children,
  selected,
  className: extraClassNames,
}) => {
  return (
    <div
      className={classNames(
        'card',
        extraClassNames,
        selected ? 'selected' : null
      )}
    >
      <div className="card-body">
        {title && <div className="card-heading">{title}</div>}
        <div className="card-content">{children}</div>
      </div>
    </div>
  );
};

export default Card;
